const ONBOARDING_QUESTIONS = [
  {
    id: 'OB-step-1',
    title: 'Tell us about your background',
    options: [
      { title: 'School Student', slug: 'SchoolStudent', categoryId: '' },
      { title: 'College Student', slug: 'CollegeStudent', categoryId: '' },
      { title: 'Graduate / Not Working', slug: 'Graduate/NotWorking', categoryId: '' },
      { title: 'Working Professional', slug: 'WorkingProfessional', categoryId: '' },
    ],
  },
  {
    id: 'OB-step-2',
    title: 'What types of course are you interested in?',
    options: [
      { title: 'Upskilling Course', slug: 'UpskillingCourse', categoryId: '' },
      { title: 'Online Degree', slug: 'OnlineDegree', categoryId: '' },
    ],
  },
  {
    id: 'OB-step-3',
    title: 'Almost done. Just choose one category that interests you the most?',
  },
];

export default ONBOARDING_QUESTIONS;
